const ml = {
    "gui.menuBar.file": "ഫയൽ",
    "gui.menuBar.edit": "തിരുത്തുക",
    "gui.menuBar.new": "പുതിയത്",
    "gui.menuBar.saveNow": "ഇപ്പോൾ സേവ് ചെയ്യുക",
    "gui.menuBar.saveAsCopy": "പകർപ്പായി സേവ് ചെയ്യുക",
    "gui.menuBar.remix": "റീമിക്സ്",
    "gui.menuBar.languageSelector": "ഭാഷ തിരഞ്ഞെടുക്കുക",
    "gui.menuBar.tutorialsLibrary": "ട്യൂട്ടോറിയലുകൾ",
    "gui.menuBar.community": "കമ്മ്യൂണിറ്റി",
    "gui.menuBar.wiki": "ഏജൻ്റ് ഡൗൺലോഡ് ചെയ്യുക",
    "gui.menuBar.restoreSprite": "സ്പ്രൈറ്റ് പുനഃസ്ഥാപിക്കുക",
    "gui.menuBar.restoreSound": "ശബ്ദം പുനഃസ്ഥാപിക്കുക",
    "gui.menuBar.restoreCostume": "വേഷം പുനഃസ്ഥാപിക്കുക",
    "gui.menuBar.restore": "പുനഃസ്ഥാപിക്കുക",
    "gui.menuBar.turboModeOff": "ടർബോ മോഡ് ഓഫ് ചെയ്യുക",
    "gui.menuBar.turboModeOn": "ടർബോ മോഡ് ഓൺ ചെയ്യുക",
    "gui.menuBar.noDeviceSelected": "ഒരു ഉപകരണവും തിരഞ്ഞെടുത്തിട്ടില്ല",
    "gui.menuBar.noConnection": "കണക്ഷൻ ഇല്ല",
    "gui.menuBar.downloadToComputer": "കമ്പ്യൂട്ടറിലേക്ക് ഡൗൺലോഡ് ചെയ്യുക",
    "gui.menuBar.checkUpdate": "അപ്ഡേറ്റ് പരിശോധിക്കുക",
    "gui.menuBar.installDriver": "ഡ്രൈവർ ഇൻസ്റ്റാൾ ചെയ്യുക",
    "gui.menuBar.clearCacheAndRestart":
        "കാഷെ മായ്ക്കുകയും വീണ്ടും ആരംഭിക്കുകയും ചെയ്യുക",
    "gui.adblockModal.title": "പരസ്യ ബ്ലോക്കർ കണ്ടെത്തി",
    "gui.adblockModal.body":
        "TIFStudio പരസ്യ ബ്ലോക്കർ കൊണ്ട് തടയപ്പെട്ടിരിക്കുന്നു. ദയവായി TIFStudio-ന് പരസ്യ ബ്ലോക്കർ ഓഫ് ചെയ്യുക.",
    "gui.adblockModal.reload": "വീണ്ടും ലോഡ് ചെയ്യുക",
    "gui.alerts.createsuccess": "പുതിയ പ്രോജക്റ്റ് സൃഷ്ടിച്ചു.",
    "gui.alerts.createcopysuccess": "പ്രോജക്റ്റ് പകർപ്പായി സേവ് ചെയ്തു.",
    "gui.alerts.createremixsuccess": "പ്രോജക്റ്റ് റീമിക്സായി സേവ് ചെയ്തു.",
    "gui.alerts.creating": "പുതിയത് സൃഷ്ടിക്കുന്നു...",
    "gui.alerts.creatingCopy": "പ്രോജക്റ്റിന്റെ പകർപ്പ് ഉണ്ടാക്കുന്നു...",
    "gui.alerts.creatingRemix": "പ്രോജക്റ്റിന്റെ റീമിക്സ് ഉണ്ടാക്കുന്നു...",
    "gui.alerts.downloading": "ഡൗൺലോഡ് ചെയ്യുന്നു...",
    "gui.alerts.loading": "ലോഡ് ചെയ്യുന്നു...",
    "gui.alerts.saving": "സേവ് ചെയ്യുന്നു...",
    "gui.alerts.savesuccess": "പ്രോജക്റ്റ് സേവ് ചെയ്തു.",
    "gui.alerts.savingError": "പ്രോജക്റ്റ് സേവ് ചെയ്യാൻ കഴിഞ്ഞില്ല.",
    "gui.alerts.cloudInfo":
        "ദയവായി ശ്രദ്ധിക്കുക, ക്ലൗഡ് വേരിയബിളുകൾ സംഖ്യകൾ മാത്രമേ പിന്തുണയ്ക്കൂ, അക്ഷരങ്ങളോ ചിഹ്നങ്ങളോ അല്ല.",
    "gui.alerts.cloudVariableFull": "ക്ലൗഡ് വേരിയബിൾ പരിധി പൂർണ്ണമായി.",
    "gui.alerts.importedSvgTitle": "അപ്‌ലോഡ് ചെയ്ത SVG ഫയലിൽ പ്രശ്നം",
    "gui.alerts.importedSvgMessage":
        "SVG ഫയൽ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല. ഇത് സാധുവായ SVG ഫയലാണോ?",
    "gui.alerts.importedSvgReset": "വീണ്ടും ശ്രമിക്കുക",
    "gui.alerts.importedSvgCancel": "റദ്ദാക്കുക",
    "gui.alerts.uploadError": "അപ്‌ലോഡ് പിശക്",
    "gui.alerts.uploadSuccess": "അപ്‌ലോഡ് വിജയകരം",
    "gui.gui.addExtension": "എക്സ്റ്റൻഷൻ ചേർക്കുക",
    "gui.gui.code": "കോഡ്",
    "gui.gui.backdrops": "പബാക്ക്ഡ്രോപ്പുകൾ",
    "gui.gui.costumes": "വേഷങ്ങൾ",
    "gui.gui.sounds": "ശബ്ദങ്ങൾ",
    "gui.gui.codeTab": "കോഡ്",
    "gui.gui.costumesTab": "വേഷങ്ങൾ",
    "gui.gui.backdropsTab": "പബാക്ക്ഡ്രോപ്പുകൾ",
    "gui.gui.soundsTab": "ശബ്ദങ്ങൾ",
    "gui.gui.defaultProjectTitle": "TIFStudio Project",
    "gui.alerts.lostPeripheralConnection":
        "TIFStudio lost connection to {extensionName}.",
    "gui.connection.unavailable.installscratchlink":
        "Make sure you have TIFStudio Agent installed and running in your system tray",
    "gui.menuBar.turnOffCamera": "ക്യാമറ ഓഫ് ചെയ്യുക",
    "gui.menu-bar.realtimeMode": "സ്ക്രാച്ച്",
    "gui.menu-bar.programMode": "പ്രോഗ്രാമ",
    "gui.hardwareConsole.send": "അയയ്ക്കുക",
    "gui.hardwareConsole.buadrate": "ബോഡ് റേറ്റ്",
    "gui.hardwareConsole.endOfLine": "ലൈനിന്റെ അവസാനം",
    "gui.hardwareConsole.hexform": "ഹെക്സ് ഫോം",
    "gui.hardwareConsole.autoScroll": "ഓട്ടോ സ്ക്രോൾ",
    "gui.hardwareHeader.upload": "അപ്‌ലോഡ്",
    "gui.stageHeader.codeStageSizeLarge": "വലിയ സ്റ്റേജ്",
    "gui.stageHeader.codeStageSizeSmall": "ചെറിയ സ്റ്റേജ്",
    "gui.stageHeader.hideStage": "സ്റ്റേജ് മറയ്ക്കുക",
    "gui.stageHeader.fullscreenControl": "ഫുൾസ്ക്രീൻ നിയന്ത്രണം",
    "gui.extensionLibrary.comingSoon": "ഉടൻ വരുന്നു",
    "gui.extensionLibrary.requires": "ആവശ്യമാണ്",
    "gui.extensionLibrary.collaboration": "ഇവയുമായി സഹകരിച്ച്",
    // Extension Library Metadata
    "gui.extensionLibrary.manufactor": "നിർമ്മാതാവ്",
    "gui.extensionLibrary.version": "പതിപ്പ്",
    "gui.extensionLibrary.author": "രചയിതാവ്",
    "gui.extensionLibrary.programMode": "പ്രോഗ്രാം മോഡ്",
    "gui.extensionLibrary.programLanguage": "പ്രോഗ്രാം ഭാഷ",
    "gui.extensionLibrary.deviceLearnMore": "കൂടുതൽ അറിയാൻ",
    "gui.extensionLibrary.extensionHelp": "സഹായം",
    "gui.extensionLibrary.Processing": "പ്രോസസ്സിംഗ്...",
    "gui.extensionLibrary.loaded": "ലോഡ് ചെയ്തു",
    "gui.extensionLibrary.notLoaded": "ലോഡ് ചെയ്തിട്ടില്ല",
    "gui.extensionLibrary.chooseAnExtension": "ഒരു എക്സ്റ്റൻഷൻ തിരഞ്ഞെടുക്കുക",
    "gui.library.filterPlaceholder": "തിരയുക",
    "gui.library.allTag": "എല്ലാം",
    "gui.library.readMore": "കൂടുതൽ വായിക്കുക",
    "gui.library.readLess": "കുറച്ച് വായിക്കുക",
    "gui.loader.message1": "സ്പ്രൈറ്റുകൾ സൃഷ്ടിക്കുന്നു ...",
    "gui.loader.message2": "ശബ്ദങ്ങൾ ലോഡ് ചെയ്യുന്നു ...",
    "gui.loader.message3": "വേഷങ്ങൾ ലോഡ് ചെയ്യുന്നു ...",
    "gui.loader.message4": "എക്സ്റ്റൻഷനുകൾ ലോഡ് ചെയ്യുന്നു ...",
    "gui.loader.message5": "ബ്ലോക്കുകൾ സൃഷ്ടിക്കുന്നു ...",
    "gui.loader.message6": "ഗണിതം ചെയ്യുന്നു ...",
    "gui.loader.message7": "ലോഡ് ചെയ്യുന്നു ...",
    "gui.loader.message8": "തയ്യാറാക്കുന്നു ...",
    "gui.loader.headline": "പ്രോജക്റ്റ് ലോഡ് ചെയ്യുന്നു",
    "gui.loader.creating": "പ്രോജക്റ്റ് സൃഷ്ടിക്കുന്നു",
    "gui.spriteLibrary.chooseASprite": "ഒരു സ്പ്രൈറ്റ് തിരഞ്ഞെടുക്കുക",
    "gui.spriteLibrary.paintASprite": "പെയിന്റ് ചെയ്യുക",
    "gui.spriteLibrary.uploadASprite": "സ്പ്രൈറ്റ് അപ്‌ലോഡ് ചെയ്യുക",
    "gui.spriteLibrary.surprise": "ആശ്ചര്യം",
    "gui.soundLibrary.chooseASound": "ഒരു ശബ്ദം തിരഞ്ഞെടുക്കുക",
    "gui.soundLibrary.record": "റെക്കോർഡ് ചെയ്യുക",
    "gui.soundLibrary.uploadASound": "ശബ്ദം അപ്‌ലോഡ് ചെയ്യുക",
    "gui.costumeLibrary.chooseACostume": "ഒരു വേഷം തിരഞ്ഞെടുക്കുക",
    "gui.costumeLibrary.paintACostume": "പെയിന്റ് ചെയ്യുക",
    "gui.costumeLibrary.uploadACostume": "വേഷം അപ്‌ലോഡ് ചെയ്യുക",
    "gui.backdropLibrary.chooseABackdrop": "ഒരു ബാക്ക്ഡ്രോപ്പ് തിരഞ്ഞെടുക്കുക",
    "gui.backdropLibrary.paintABackdrop": "പെയിന്റ് ചെയ്യുക",
    "gui.backdropLibrary.uploadABackdrop": "ബാക്ക്ഡ്രോപ്പ് അപ്‌ലോഡ് ചെയ്യുക",
    "gui.spriteSelector.addSpriteFromLibrary": "ഒരു സ്പ്രൈറ്റ് തിരഞ്ഞെടുക്കുക",
    "gui.spriteSelector.addSpriteFromPaint": "പെയിന്റ് ചെയ്യുക",
    "gui.spriteSelector.addSpriteFromSurprise": "ആശ്ചര്യം",
    "gui.spriteSelector.addSpriteFromFileUpload": "സ്പ്രൈറ്റ് അപ്‌ലോഡ് ചെയ്യുക",
    "gui.stageSelector.addBackdropFromLibrary":
        "ഒരു ബാക്ക്ഡ്രോപ്പ് തിരഞ്ഞെടുക്കുക",
    "gui.stageSelector.addBackdropFromPaint": "പെയിന്റ് ചെയ്യുക",
    "gui.stageSelector.addBackdropFromSurprise": "ആശ്ചര്യം",
    "gui.stageSelector.addBackdropFromFileUpload":
        "ബാക്ക്ഡ്രോപ്പ് അപ്‌ലോഡ് ചെയ്യുക",
    "gui.stageSelector.stage": "സ്റ്റേജ്",
    "gui.stageSelector.backdrops": "ബാക്ക്ഡ്രോപ്പുകൾ",
    "gui.spriteSelectorItem.contextMenuDuplicate": "പകർപ്പുണ്ടാക്കുക",
    "gui.spriteSelectorItem.contextMenuExport": "എക്സ്പോർട്ട് ചെയ്യുക",
    "gui.spriteSelectorItem.contextMenuDelete": "ഡിലീറ്റ് ചെയ്യുക",
    "gui.spriteInfo.sprite": "സ്പ്രൈറ്റ്",
    "gui.spriteInfo.size": "വലുപ്പം",
    "gui.spriteInfo.show": "കാണിക്കുക",
    "gui.spriteInfo.changeSize": "വലുപ്പം മാറ്റുക",
    "gui.spriteInfo.changeX": "X മാറ്റുക",
    "gui.spriteInfo.changeY": "Y മാറ്റുക",
    "gui.spriteInfo.direction": "ദിശ",
    "gui.spriteInfo.changeDirection": "ദിശ മാറ്റുക",
    "gui.spriteInfo.isVisible": "ദൃശ്യമാണ്",
    "gui.deviceLibrary.chooseADevice": "ഒരു ഉപകരണം തിരഞ്ഞെടുക്കുക",
    "gui.deviceLibrary.deviceUrl": "ഉപകരണ URL നൽകുക",
    "gui.deviceLibrary.arduinoTag": "Arduino",
    "gui.deviceLibrary.microbitTag": "Micro:bit",
    "gui.deviceLibrary.esp32Tag": "ESP32",
    "gui.deviceLibrary.kitTag": "കിറ്റ്",
    "gui.deviceLibrary.shieldTag": "ഷീൽഡ്",
    "gui.playButton.play": "പ്ലേ ചെയ്യുക",
    "gui.playButton.stop": "നിർത്തുക",
    "gui.gui.variableScopeOptionAllSprites": "എല്ലാ സ്പ്രൈറ്റുകൾക്കും",
    "gui.gui.variableScopeOptionSpriteOnly": "ഈ സ്പ്രൈറ്റിന് മാത്രം",
    "gui.gui.cloudVariableOption": "ക്ലൗഡ് വേരിയബിൾ (സെർവറിൽ സംഭരിച്ചത്)",
    "gui.gui.variablePromptDefaultValue": "എന്റെ വേരിയബിൾ",
    "gui.gui.listVariable": "ഒരു ലിസ്റ്റ് ഉണ്ടാക്കുക",
    "gui.gui.makeAVariable": "ഒരു വേരിയബിൾ ഉണ്ടാക്കുക",
    "gui.gui.newVariable": "പുതിയ വേരിയബിൾ",
    "gui.soundEditor.sound": "ശബ്ദം",
    "gui.soundEditor.play": "പ്ലേ",
    "gui.soundEditor.stop": "നിർത്തുക",
    "gui.soundEditor.copy": "കോപ്പി",
    "gui.soundEditor.paste": "പേസ്റ്റ്",
    "gui.soundEditor.copyToNew": "പുതിയതിലേക്ക് കോപ്പി ചെയ്യുക",
    "gui.soundEditor.delete": "ഡിലീറ്റ്",
    "gui.soundEditor.save": "സേവ്",
    "gui.soundEditor.undo": "പഴയപടി",
    "gui.soundEditor.redo": "വീണ്ടും ചെയ്യുക",
    "gui.soundEditor.faster": "വേഗത്തിൽ",
    "gui.soundEditor.slower": "പതുക്കെ",
    "gui.soundEditor.echo": "എക്കോ",
    "gui.soundEditor.robot": "റോബോട്ട്",
    "gui.soundEditor.louder": "ഉച്ചത്തിൽ",
    "gui.soundEditor.softer": "മൃദുവായി",
    "gui.soundEditor.reverse": "റിവേഴ്സ്",
    "gui.soundEditor.fadeOut": "ഫേഡ് ഔട്ട്",
    "gui.soundEditor.fadeIn": "ഫേഡ് ഇൻ",
    "gui.soundEditor.mute": "മ്യൂട്ട്",
    "paint.paintEditor.hue": "നിറം",
    "paint.paintEditor.saturation": "സാച്ചുറേഷൻ",
    "paint.paintEditor.brightness": "തെളിച്ചം",
    "paint.paintEditor.fill": "നിറയ്ക്കുക",
    "paint.paintEditor.costume": "വേഷം",
    "paint.paintEditor.group": "ഗ്രൂപ്പ് ചെയ്യുക",
    "paint.paintEditor.ungroup": "ഗ്രൂപ്പ് നീക്കം ചെയ്യുക",
    "paint.paintEditor.undo": "പഴയപടി",
    "paint.paintEditor.redo": "വീണ്ടും ചെയ്യുക",
    "paint.paintEditor.forward": "മുന്നിലേക്ക് കൊണ്ടുവരിക",
    "paint.paintEditor.backward": "പിന്നിലേക്ക് അയയ്ക്കുക",
    "paint.paintEditor.front": "ഏറ്റവും മുന്നിൽ",
    "paint.paintEditor.back": "ഏറ്റവും പിന്നിൽ",
    "paint.paintEditor.more": "കൂടുതൽ",
    "paint.modeTools.brushSize": "ബ്രഷിന്റെ വലുപ്പം",
    "paint.modeTools.eraserSize": "ഇറേസറിന്റെ വലുപ്പം",
    "paint.modeTools.copy": "കോപ്പി",
    "paint.modeTools.paste": "പേസ്റ്റ്",
    "paint.modeTools.delete": "ഡിലീറ്റ്",
    "paint.modeTools.curved": "വളഞ്ഞത്",
    "paint.modeTools.pointed": "മൂർച്ചയുള്ളത്",
    "paint.modeTools.thickness": "കട്ടി",
    "paint.modeTools.flipHorizontal": "തിരശ്ചീനമായി മറിക്കുക",
    "paint.modeTools.flipVertical": "ലംബമായി മറിക്കുക",
    "paint.modeTools.filled": "നിറച്ചത്",
    "paint.modeTools.outlined": "ഔട്ട്‌ലൈൻ",
    "paint.paintEditor.bitmap": "ബിറ്റ്മാപ്പിലേക്ക് മാറ്റുക",
    "paint.paintEditor.vector": "വെക്റ്ററിലേക്ക് മാറ്റുക",
    "paint.paintEditor.stroke": "ഔട്ട്‌ലൈൻ",
    "paint.brushMode.brush": "ബ്രഷ്",
    "paint.eraserMode.eraser": "ഇറേസർ",
    "paint.fillMode.fill": "നിറയ്ക്കുക",
    "paint.lineMode.line": "വര",
    "paint.ovalMode.oval": "ദീർഘവൃത്തം",
    "paint.rectMode.rect": "ചതുരം/ആയതം",
    "paint.reshapeMode.reshape": "രൂപം മാറ്റുക",
    "paint.roundedRectMode.roundedRect": "വൃത്താകൃതിയിലുള്ള ആയതം",
    "paint.selectMode.select": "തിരഞ്ഞെടുക്കുക",
    "paint.textMode.text": "ടെക്സ്റ്റ്",
    "paint.colorPicker.swap": "സ്വാപ്പ്",
    "gui.uploadProgress.uploading": "അപ്‌ലോഡ് ചെയ്യുന്നു",
    "gui.uploadProgress.uploadSuccess": "അപ്‌ലോഡ് വിജയകരം",
    "gui.uploadProgress.uploadError": "അപ്‌ലോഡ് പിശക്",
    "gui.uploadProgress.close": "അടയ്ക്കുക",
    "gui.uploadProgress.abort": "റദ്ദാക്കുക",
    "gui.connection.connect": "കണക്ട് ചെയ്യുക",
    "gui.connection.disconnect": "വിച്ഛേദിക്കുക",
    "gui.connection.connected": "കണക്ടഡ്",
    "gui.connection.connecting": "കണക്ട് ചെയ്യുന്നു...",
    "gui.connection.error": "പിശക്",
    "gui.connection.unavailable": "ലഭ്യമല്ല",
    "gui.connection.noDevicesFound": "ഒരു ഉപകരണവും കണ്ടെത്തിയില്ല",
    "gui.connection.scanning": "സ്കാൻ ചെയ്യുന്നു...",
    "gui.connection.help": "സഹായം",
    "gui.connection.refresh": "പുതുക്കുക",
    "blockly.deleteBlock": "ബ്ലോക്ക് ഡിലീറ്റ് ചെയ്യുക",
    "blockly.duplicateBlock": "പകർപ്പുണ്ടാക്കുക",
    "blockly.addComment": "കമന്റ് ചേർക്കുക",
    "blockly.removeComment": "കമന്റ് നീക്കം ചെയ്യുക",
    "blockly.externalInput": "ബാഹ്യ ഇൻപുട്ട്",
    "blockly.inlineInput": "ഇൻലൈൻ ഇൻപുട്ട്",
    "blockly.disableBlock": "ബ്ലോക്ക് അൺഎബിൾ ചെയ്യുക",
    "blockly.enableBlock": "ബ്ലോക്ക് എനേബിൾ ചെയ്യുക",
    "blockly.expandBlock": "ബ്ലോക്ക് വിപുലീകരിക്കുക",
    "blockly.collapseBlock": "ബ്ലോക്ക് ചുരുക്കുക",
    "blockly.help": "സഹായം",
    "blockly.undo": "പഴയപടി",
    "blockly.redo": "വീണ്ടും ചെയ്യുക",
    "blockly.cleanUp": "ബ്ലോക്കുകൾ വൃത്തിയാക്കുക",
    "blockly.sortByCategory": "വിഭാഗം അനുസരിച്ച് ക്രമീകരിക്കുക",
    "blockly.workspaceComment": "വർക്ക്‌സ്പേസ് കമന്റ്",
    "blockly.exportToHtml": "HTML ആയി എക്സ്പോർട്ട് ചെയ്യുക",
    "blockly.snapToGrid": "ഗ്രിഡിലേക്ക് സ്നാപ്പ് ചെയ്യുക",
    "blockly.cannotDeleteVariable": "ഈ വേരിയബിൾ ഡിലീറ്റ് ചെയ്യാനാവില്ല",
    "blockly.renameVariable": "വേരിയബിളിന്റെ പേര് മാറ്റുക",
    "blockly.newVariable": "പുതിയ വേരിയബിൾ",
    "blockly.renameVariableTitle": 'എല്ലാ "%1" വേരിയബിളുകളുടെയും പേര് മാറ്റുക:',
    "blockly.variableAlreadyExists": '"%1" എന്ന പേരിൽ വേരിയബിൾ നിലവിലുണ്ട്',

    // Device translations
    "gui.device.unselectDevice.name": "ഉപകരണം അൺസിലക്ട് ചെയ്യുക",
    "gui.device.unselectDevice.description":
        "ഉപകരണം അൺസിലക്ട് ചെയ്ത് ശുദ്ധമായ റിയൽടൈം പ്രോഗ്രാമിങ് മോഡിലേക്ക് മടങ്ങുക.",
    "gui.device.connectingMessage": "കണക്ട് ചെയ്യുന്നു",
    "gui.device.arduinoUno.description":
        "ഇലക്ട്രോണിക്സും കോഡിങും ആരംഭിക്കാൻ ഉള്ള മികച്ച ബോർഡ്.",
    "gui.device.arduinoNano.description":
        "നിന്റെ പ്രോജക്റ്റുകൾ നിർമ്മിക്കാൻ ക്ലാസിക് ചെറിയ ബോർഡ്.",
    "gui.device.arduinoLeonardo.description":
        "മൗസോ കീബോർഡോ ആയി പ്രവർത്തിക്കാൻ കഴിയുന്ന ക്ലാസിക് Arduino ബോർഡ്.",
    "gui.device.arduinoMega2560.description":
        "54 ഡിജിറ്റൽ പിൻ, 16 അനലോഗ് ഇൻപുട്ട്, 4 സീരിയൽ പോർട്ടുകളുള്ള 8-ബിറ്റ് ബോർഡ്.",
    "gui.device.arduinoUnoR4Minima.description":
        "മെച്ചപ്പെട്ട പ്രകടനവും കൂടുതൽ മെമ്മറിയും നൽകുന്നു, നിലവിലുള്ള ഷീൽഡുകളും ആക്സസറികളും ഉപയോഗിക്കാം.",
    "gui.device.arduinoUnoR4Wifi.description":
        "Wi-Fi, Bluetooth കണക്ടിവിറ്റി, 12x8 LED മാട്രിക്സ് ഉൾപ്പെടെ.",
    "gui.device.esp32.description":
        "Wi-Fi, Bluetooth സപ്പോർട്ടുള്ള സമ്പന്ന ഫീച്ചറുകളുള്ള കൺട്രോൾ ബോർഡ്.",
    "gui.device.esp32S3.description":
        "AI ആക്സിലറേറ്ററും സമ്പന്ന പെരിഫറൽ സെറ്റും ഉള്ള കുറഞ്ഞ പവർ IoT ബോർഡ്.",
    "gui.device.esp8266NodeMCU.description":
        "കുറഞ്ഞ വിലയുള്ള Wi-Fi SOC കൺട്രോൾ ബോർഡ്.",
    "gui.device.k210MaixDock.description":
        "K210 RISC-V ചിപ്പ് അടിസ്ഥാനമാക്കിയുള്ള ബേസിക് കൺട്രോൾ ബോർഡ്.",
    "gui.device.k210Maixduino.description":
        "ESP32 ഉം K210 RISC-V ഉം ഉള്ള ബോർഡ്.",
    "gui.device.raspberryPiPicoIconURL.description":
        "നിന്റെ ഇലക്ട്രോണിക്സ് ആശയങ്ങൾ ജീവനുള്ളതാക്കുന്ന ഉപയോക്തൃസൗഹൃദ മൈക്രോകൺട്രോളർ.",
    "gui.device.raspberryPiPicoWIconURL.description":
        "ബിൽറ്റ്-ഇൻ 2.4 GHz Wi-Fi & Bluetooth 5.2 ഉള്ള Pico.",
    "gui.device.raspberryPiPico2IconURL.description":
        "ഉയർന്ന പ്രകടനമുള്ള ഡ്യുവൽ-കോർ MCU, കൂടുതൽ RAM & ഫ്ലാഷ്.",
    "gui.device.raspberryPiPico2WIconURL.description":
        "ബിൽറ്റ്-ഇൻ Wi-Fi & Bluetooth ഉപയോഗിച്ച് വയർലെസ് IoT പ്രോജക്ടുകൾക്ക് അനുയോജ്യം.",
    "gui.device.microbit.description":
        "ഡിജിറ്റൽ കഴിവുകൾ പഠിക്കാൻ മാറ്റിമറിക്കുന്ന പോക്കറ്റ് സൈസ് കമ്പ്യൂട്ടർ.",
    "gui.device.microbitV2.description":
        "മെച്ചപ്പെട്ട പ്രോസസർ, ബിൽറ്റ്-ഇൻ സ്പീക്കർ, മൈക്രോഫോൺ, ടച്ച് ലോഗോ.",
    "gui.device.makeymakey.description": "ഏത് വസ്തുവിനെയും കീ ആക്കി മാറ്റുക.",
    "gui.sharedMessages.sprite": "Tiffy",
    "gui.device.tifBot.description":
        "TIF-BOT എന്നത് Wi-Fi, Bluetooth എന്നിവയോടൊപ്പം റോബോട്ടിക്സ്, IoT പ്രോജക്റ്റുകൾക്കായുള്ള സമൃദ്ധ peripherals ഉള്ള ESP32-S3 അടിസ്ഥാനമാക്കിയ ബോർഡാണ്.",
    "gui.device.lightWingDrone.description":
        "ലൈറ്റ് വിംഗ് ഡ്രോൺ എന്നത് വിപുലമായ സ്ഥിരതയും Wi-Fi നിയന്ത്രണവുമുള്ള ഉയർന്ന പ്രകടനമുള്ള ESP32-S3 അടിസ്ഥാനമാക്കിയ ഫ്ലൈറ്റ് കൺട്രോളറാണ്.",
    "gui.device.roboticDog.description":
        "Robotic Dog എന്നത് Arduino Nano ഉപയോഗിച്ച് പ്രവർത്തിക്കുന്ന ഒരു സ്മാർട്ട് നാലുകാലി റോബോട്ടാണ്, ഇത് ജീവനുള്ളതുപോലുള്ള ചലനങ്ങളും തടസ്സങ്ങളെ ഒഴിവാക്കാനുള്ള കഴിവും ഉള്ളതാണ്.",
    "gui.device.roboticArm.description":
        "Robotic Arm എന്നത് Arduino Nano ഉപയോഗിച്ച് പ്രവർത്തിക്കുന്ന ഒരു മൾട്ടി-ആക്സിസ് മാനിപ്പുലേറ്ററാണ്, ഇത് കൃത്യമായ ജോലികൾക്കും ഓട്ടോമേഷൻ പഠനത്തിനുമായി രൂപകൽപ്പന ചെയ്തിരിക്കുന്നു.",
    // Music
    "music.categoryName": "സംഗീതം",
    "music.playDrumForBeats": "ഡ്രം [DRUM] [BEATS] ബീറ്റുകൾക്ക് വായിക്കുക",
    "music.restForBeats": "[BEATS] ബീറ്റുകൾക്ക് വിശ്രമം",
    "music.playNoteForBeats": "നോട്ട് [NOTE] [BEATS] ബീറ്റുകൾക്ക് വായിക്കുക",
    "music.setInstrument": "വാദ്യം [INSTRUMENT] ആയി നിശ്ചയിക്കുക",
    "music.changeTempo": "ടെമ്പോ [TEMPO] മാറ്റുക",
    "music.setTempo": "ടെമ്പോ [TEMPO] ആയി നിശ്ചയിക്കുക",
    "music.getTempo": "ടെമ്പോ",
    "music.drumBass": "(2) ബാസ് ഡ്രം",
    "music.drumBongo": "(13) ബോംഗോ",
    "music.drumCabasa": "(15) കബാസ",
    "music.drumClaves": "(9) ക്ലാസ്സ്",
    "music.drumClosedHiHat": "(6) ക്ലോസ്ഡ് ഹൈ-ഹാറ്റ്",
    "music.drumConga": "(14) കോംഗാ",
    "music.drumCowbell": "(11) കൗബെൽ",
    "music.drumCrashCymbal": "(4) ക്രാഷ് സിംബൽ",
    "music.drumCuica": "(18) കുയിക്ക",
    "music.drumGuiro": "(16) ഗുയിറോ",
    "music.drumHandClap": "(8) കൈയടി",
    "music.drumOpenHiHat": "(5) ഓപ്പൺ ഹൈ-ഹാറ്റ്",
    "music.drumSideStick": "(3) സൈഡ് സ്റ്റിക്",
    "music.drumSnare": "(1) സ്നെയർ ഡ്രം",
    "music.drumTambourine": "(7) ടാംബോറിൻ",
    "music.drumTriangle": "(12) ട്രയാംഗിൾ",
    "music.drumVibraslap": "(17) വൈബ്രാസ് ലാപ്പ്",
    "music.drumWoodBlock": "(10) വുഡ് ബ്ലോക്ക്",
    "music.instrumentBass": "(6) ബാസ്",
    "music.instrumentBassoon": "(14) ബസൂൺ",
    "music.instrumentCello": "(8) സെലോ",
    "music.instrumentChoir": "(15) ക്വയർ",
    "music.instrumentClarinet": "(10) ക്ലാരിനെറ്റ്",
    "music.instrumentElectricGuitar": "(5) ഇലക്ട്രിക് ഗിറ്റാർ",
    "music.instrumentElectricPiano": "(2) ഇലക്ട്രിക് പിയാനോ",
    "music.instrumentFlute": "(12) പുല്ലാങ്കുഴൽ",
    "music.instrumentGuitar": "(4) ഗിറ്റാർ",
    "music.instrumentMarimba": "(19) മരിമ്പ",
    "music.instrumentMusicBox": "(17) മ്യൂസിക് ബോക്സ്",
    "music.instrumentOrgan": "(3) ഓർഗൻ",
    "music.instrumentPiano": "(1) പിയാനോ",
    "music.instrumentPizzicato": "(7) പിസിക്കറ്റോ",
    "music.instrumentSaxophone": "(11) സാക്സോഫോൺ",
    "music.instrumentSteelDrum": "(18) സ്റ്റീൽ ഡ്രം",
    "music.instrumentSynthLead": "(20) സിന്ത് ലീഡ്",
    "music.instrumentSynthPad": "(21) സിന്ത് പാഡ്",
    "music.instrumentTrombone": "(9) ട്രോംബോൺ",
    "music.instrumentVibraphone": "(16) വൈബ്രാഫോൺ",
    "music.instrumentWoodenFlute": "(13) വുഡൻ ഫ്ലൂട്ട്",

    // Pen
    "pen.categoryName": "പേന",
    "pen.clear": "എല്ലാം മായ്ക്കുക",
    "pen.stamp": "സ്റ്റാമ്പ് ചെയ്യുക",
    "pen.penDown": "പേന താഴേക്ക്",
    "pen.penUp": "പേന മുകളിലേക്ക്",
    "pen.setColor": "പേനയുടെ നിറം [COLOR] ആയി നിശ്ചയിക്കുക",
    "pen.changeSize": "പേനയുടെ വലുപ്പം [SIZE] മാറ്റുക",
    "pen.setSize": "പേനയുടെ വലുപ്പം [SIZE] ആയി നിശ്ചയിക്കുക",
    "pen.colorMenu.color": "നിറം",
    "pen.colorMenu.saturation": "സാച്ചുറേഷൻ (Saturation)",
    "pen.colorMenu.brightness": "തെളിച്ചം (Brightness)",
    "pen.colorMenu.transparency": "സുതാര്യത",

    // Extension Library Names and Descriptions
    "gui.extension.music.name": "സംഗീതം",
    "gui.extension.music.description": "വാദ്യോപകരണങ്ങളും ഡ്രംസും വായിക്കുക.",
    "gui.extension.pen.name": "പേന",
    "gui.extension.pen.description":
        "നിങ്ങളുടെ സ്പ്രൈറ്റുകൾ ഉപയോഗിച്ച് ചിത്രം വരയ്ക്കുക.",
    "gui.extension.videosensing.name": "വീഡിയോ സെൻസിംഗ്",
    "gui.extension.videosensing.description":
        "ക്യാമറ ഉപയോഗിച്ച് ചലനം തിരിച്ചറിയുക.",
    "gui.extension.poseface.name": "ഫേസ് സെൻസിംഗ്",
    "gui.extension.poseface.description":
        "ക്യാമറ ഉപയോഗിച്ച് മുഖത്തെ ചലനങ്ങൾ തിരിച്ചറിയുക.",
    "gui.extension.posehand.name": "ഹാൻഡ് സെൻസിംഗ്",
    "gui.extension.posehand.description":
        "ക്യാമറ ഉപയോഗിച്ച് കൈകളുടെ ചലനം തിരിച്ചറിയുക.",
    "gui.extension.posebody.name": "ബോഡി പോസ് സെൻസിംഗ്",
    "gui.extension.posebody.description":
        "ക്യാമറ ഉപയോഗിച്ച് ശരീരത്തിന്റെ ചലനം തിരിച്ചറിയുക.",
    "gui.extension.teachablemachine.name": "ടീച്ചബിൾ മെഷീൻ",
    "gui.extension.teachablemachine.description":
        "നിങ്ങളുടെ ക്യാമറ ഉപയോഗിച്ച് കസ്റ്റം മെഷീൻ ലേണിംഗ് മോഡലുകൾ ഉപയോഗിക്കുക.",
    "gui.extension.text2speech.name": "ടെക്സ്റ്റ് ടു സ്പീച്ച്",
    "gui.extension.text2speech.description":
        "നിങ്ങളുടെ പ്രോജക്റ്റിനെ സംസാരിപ്പിക്കുക.",
    "gui.extension.translate.name": "വിവർത്തനം",
    "gui.extension.translate.description":
        "വാചകങ്ങൾ പല ഭാഷകളിലേക്ക് വിവർത്തനം ചെയ്യുക.",
    "gui.extension.makeymakey.name": "മേക്കി മേക്കി",
    "gui.extension.makeymakey.description":
        "ഏത് വസ്തുവിനെയും ഒരു കീ (Key) ആക്കി മാറ്റുക.",

    // Arduino Translations
    "arduinoUno.category.pins": "പിൻ",
    "arduinoUno.category.serial": "സീരിയൽ",
    "arduinoUno.category.data": "ഡാറ്റ",

    "arduinoNano.category.pins": "പിൻ",
    "arduinoNano.category.serial": "സീരിയൽ",
    "arduinoNano.category.data": "ഡാറ്റ",

    "arduinoLeonardo.category.pins": "പിൻ",
    "arduinoLeonardo.category.serial": "സീരിയൽ",
    "arduinoLeonardo.category.data": "ഡാറ്റ",

    "arduinoMega2560.category.pins": "പിൻ",
    "arduinoMega2560.category.serial": "സീരിയൽ",
    "arduinoMega2560.category.data": "ഡാറ്റ",

    "arduinoEsp32.category.pins": "പിൻ",
    "arduinoEsp32.category.serial": "സീരിയൽ",
    "arduinoEsp32.category.data": "ഡാറ്റ",

    "arduinoEsp8266.category.pins": "പിൻ",
    "arduinoEsp8266.category.serial": "സീരിയൽ",
    "arduinoEsp8266.category.data": "ഡാറ്റ",

    "arduinoK210.category.pins": "പിൻ",
    "arduinoK210.category.serial": "സീരിയൽ",
    "arduinoK210.category.data": "ഡാറ്റ",

    "arduinoRaspberryPiPico.category.pins": "പിൻ",
    "arduinoRaspberryPiPico.category.serial": "സീരിയൽ",
    "arduinoRaspberryPiPico.category.data": "ഡാറ്റ",

    // Arduino Uno Blocks
    "arduinoUno.modeMenu.input": "ഇൻപുട്ട്",
    "arduinoUno.modeMenu.output": "ഔട്ട്പുട്ട്",
    "arduinoUno.modeMenu.inputPullup": "ഇൻപുട്ട്-പുൾഅപ്പ്",
    "arduinoUno.levelMenu.high": "ഹൈ (High)",
    "arduinoUno.levelMenu.low": "ലോ (Low)",
    "arduinoUno.pins.setPinMode": "പിൻ [PIN] മോഡ് [MODE] സെറ്റ് ചെയ്യുക",
    "arduinoUno.pins.setDigitalOutput":
        "ഡിജിറ്റൽ പിൻ [PIN] ഔട്ട് [LEVEL] സെറ്റ് ചെയ്യുക",
    "arduinoUno.pins.setPwmOutput": "PWM പിൻ [PIN] ഔട്ട് [OUT] സെറ്റ് ചെയ്യുക",
    "arduinoUno.pins.readDigitalPin": "ഡിജിറ്റൽ പിൻ [PIN] റീഡ് ചെയ്യുക",
    "arduinoUno.pins.readAnalogPin": "അനലോഗ് പിൻ [PIN] റീഡ് ചെയ്യുക",
    "arduinoUno.pins.setServoOutput":
        "സെർവോ പിൻ [PIN] ഔട്ട് [OUT] സെറ്റ് ചെയ്യുക",
    "arduinoUno.pins.attachInterrupt":
        "ഇന്ററപ്റ്റ് പിൻ [PIN] മോഡ് [MODE] അറ്റാച്ച് ചെയ്യുക",
    "arduinoUno.pins.detachInterrupt":
        "ഇന്ററപ്റ്റ് പിൻ [PIN] ഡിറ്റാച്ച് ചെയ്യുക",
    "arduinoUno.serial.serialBegin": "സീരിയൽ തുടങ്ങുക ബോഡ്‌റേറ്റ് [VALUE]",
    "arduinoUno.serial.serialPrint": "സീരിയൽ പ്രിന്റ് [VALUE] [EOL]",
    "arduinoUno.serial.serialAvailable": "സീരിയൽ ലഭ്യമായ ഡാറ്റ നീളം",
    "arduinoUno.serial.serialReadAByte": "സീരിയൽ ഒരു ബൈറ്റ് റീഡ് ചെയ്യുക",
    "arduinoUno.data.dataMap":
        "[DATA] നെ ([ARG0], [ARG1]) ൽ നിന്ന് ([ARG2], [ARG3]) ലേക്ക് മാപ്പ് ചെയ്യുക",

    // Arduino Nano Blocks
    "arduinoNano.modeMenu.input": "ഇൻപുട്ട്",
    "arduinoNano.modeMenu.output": "ഔട്ട്പുട്ട്",
    "arduinoNano.modeMenu.inputPullup": "ഇൻപുട്ട്-പുൾഅപ്പ്",
    "arduinoNano.levelMenu.high": "ഹൈ (High)",
    "arduinoNano.levelMenu.low": "ലോ (Low)",
    "arduinoNano.pins.setPinMode": "പിൻ [PIN] മോഡ് [MODE] സെറ്റ് ചെയ്യുക",
    "arduinoNano.pins.setDigitalOutput":
        "ഡിജിറ്റൽ പിൻ [PIN] ഔട്ട് [LEVEL] സെറ്റ് ചെയ്യുക",
    "arduinoNano.pins.setPwmOutput": "PWM പിൻ [PIN] ഔട്ട് [OUT] സെറ്റ് ചെയ്യുക",
    "arduinoNano.pins.readDigitalPin": "ഡിജിറ്റൽ പിൻ [PIN] റീഡ് ചെയ്യുക",
    "arduinoNano.pins.readAnalogPin": "അനലോഗ് പിൻ [PIN] റീഡ് ചെയ്യുക",
    "arduinoNano.pins.setServoOutput":
        "സെർവോ പിൻ [PIN] ഔട്ട് [OUT] സെറ്റ് ചെയ്യുക",
    "arduinoNano.pins.attachInterrupt":
        "ഇന്ററപ്റ്റ് പിൻ [PIN] മോഡ് [MODE] അറ്റാച്ച് ചെയ്യുക",
    "arduinoNano.pins.detachInterrupt":
        "ഇന്ററപ്റ്റ് പിൻ [PIN] ഡിറ്റാച്ച് ചെയ്യുക",
    "arduinoNano.serial.serialBegin": "സീരിയൽ തുടങ്ങുക ബോഡ്‌റേറ്റ് [VALUE]",
    "arduinoNano.serial.serialPrint": "സീരിയൽ പ്രിന്റ് [VALUE] [EOL]",
    "arduinoNano.serial.serialAvailable": "സീരിയൽ ലഭ്യമായ ഡാറ്റ നീളം",
    "arduinoNano.serial.serialReadAByte": "സീരിയൽ ഒരു ബൈറ്റ് റീഡ് ചെയ്യുക",
    "arduinoNano.data.dataMap":
        "[DATA] നെ ([ARG0], [ARG1]) ൽ നിന്ന് ([ARG2], [ARG3]) ലേക്ക് മാപ്പ് ചെയ്യുക",

    // Arduino Leonardo Blocks
    "arduinoLeonardo.modeMenu.input": "ഇൻപുട്ട്",
    "arduinoLeonardo.modeMenu.output": "ഔട്ട്പുട്ട്",
    "arduinoLeonardo.modeMenu.inputPullup": "ഇൻപുട്ട്-പുൾഅപ്പ്",
    "arduinoLeonardo.levelMenu.high": "ഹൈ (High)",
    "arduinoLeonardo.levelMenu.low": "ലോ (Low)",
    "arduinoLeonardo.pins.setPinMode": "പിൻ [PIN] മോഡ് [MODE] സെറ്റ് ചെയ്യുക",
    "arduinoLeonardo.pins.setDigitalOutput":
        "ഡിജിറ്റൽ പിൻ [PIN] ഔട്ട് [LEVEL] സെറ്റ് ചെയ്യുക",
    "arduinoLeonardo.pins.setPwmOutput":
        "PWM പിൻ [PIN] ഔട്ട് [OUT] സെറ്റ് ചെയ്യുക",
    "arduinoLeonardo.pins.readDigitalPin": "ഡിജിറ്റൽ പിൻ [PIN] റീഡ് ചെയ്യുക",
    "arduinoLeonardo.pins.readAnalogPin": "അനലോഗ് പിൻ [PIN] റീഡ് ചെയ്യുക",
    "arduinoLeonardo.pins.setServoOutput":
        "സെർവോ പിൻ [PIN] ഔട്ട് [OUT] സെറ്റ് ചെയ്യുക",
    "arduinoLeonardo.pins.attachInterrupt":
        "ഇന്ററപ്റ്റ് പിൻ [PIN] മോഡ് [MODE] അറ്റാച്ച് ചെയ്യുക",
    "arduinoLeonardo.pins.detachInterrupt":
        "ഇന്ററപ്റ്റ് പിൻ [PIN] ഡിറ്റാച്ച് ചെയ്യുക",
    "arduinoLeonardo.serial.serialBegin": "സീരിയൽ തുടങ്ങുക ബോഡ്‌റേറ്റ് [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "സീരിയൽ പ്രിന്റ് [VALUE] [EOL]",
    "arduinoLeonardo.serial.serialAvailable": "സീരിയൽ ലഭ്യമായ ഡാറ്റ നീളം",
    "arduinoLeonardo.serial.serialReadAByte": "സീരിയൽ ഒരു ബൈറ്റ് റീഡ് ചെയ്യുക",
    "arduinoLeonardo.data.dataMap":
        "[DATA] നെ ([ARG0], [ARG1]) ൽ നിന്ന് ([ARG2], [ARG3]) ലേക്ക് മാപ്പ് ചെയ്യുക",

    // Arduino Mega2560 Blocks
    "arduinoMega2560.modeMenu.input": "ഇൻപുട്ട്",
    "arduinoMega2560.modeMenu.output": "ഔട്ട്പുട്ട്",
    "arduinoMega2560.modeMenu.inputPullup": "ഇൻപുട്ട്-പുൾഅപ്പ്",
    "arduinoMega2560.levelMenu.high": "ഹൈ (High)",
    "arduinoMega2560.levelMenu.low": "ലോ (Low)",
    "arduinoMega2560.pins.setPinMode": "പിൻ [PIN] മോഡ് [MODE] സെറ്റ് ചെയ്യുക",
    "arduinoMega2560.pins.setDigitalOutput":
        "ഡിജിറ്റൽ പിൻ [PIN] ഔട്ട് [LEVEL] സെറ്റ് ചെയ്യുക",
    "arduinoMega2560.pins.setPwmOutput":
        "PWM പിൻ [PIN] ഔട്ട് [OUT] സെറ്റ് ചെയ്യുക",
    "arduinoMega2560.pins.readDigitalPin": "ഡിജിറ്റൽ പിൻ [PIN] റീഡ് ചെയ്യുക",
    "arduinoMega2560.pins.readAnalogPin": "അനലോഗ് പിൻ [PIN] റീഡ് ചെയ്യുക",
    "arduinoMega2560.pins.setServoOutput":
        "സെർവോ പിൻ [PIN] ഔട്ട് [OUT] സെറ്റ് ചെയ്യുക",
    "arduinoMega2560.pins.attachInterrupt":
        "ഇന്ററപ്റ്റ് പിൻ [PIN] മോഡ് [MODE] അറ്റാച്ച് ചെയ്യുക",
    "arduinoMega2560.pins.detachInterrupt":
        "ഇന്ററപ്റ്റ് പിൻ [PIN] ഡിറ്റാച്ച് ചെയ്യുക",
    "arduinoMega2560.serial.serialBegin": "സീരിയൽ തുടങ്ങുക ബോഡ്‌റേറ്റ് [VALUE]",
    "arduinoMega2560.serial.serialPrint": "സീരിയൽ പ്രിന്റ് [VALUE] [EOL]",
    "arduinoMega2560.serial.serialAvailable": "സീരിയൽ ലഭ്യമായ ഡാറ്റ നീളം",
    "arduinoMega2560.serial.serialReadAByte": "സീരിയൽ ഒരു ബൈറ്റ് റീഡ് ചെയ്യുക",
    "arduinoMega2560.data.dataMap":
        "[DATA] നെ ([ARG0], [ARG1]) ൽ നിന്ന് ([ARG2], [ARG3]) ലേക്ക് മാപ്പ് ചെയ്യുക",

    // Arduino ESP32 Blocks
    "arduinoEsp32.modeMenu.input": "ഇൻപുട്ട്",
    "arduinoEsp32.modeMenu.output": "ഔട്ട്പുട്ട്",
    "arduinoEsp32.modeMenu.inputPullup": "ഇൻപുട്ട്-പുൾഅപ്പ്",
    "arduinoEsp32.levelMenu.high": "ഹൈ (High)",
    "arduinoEsp32.levelMenu.low": "ലോ (Low)",
    "arduinoEsp32.pins.setPinMode": "പിൻ [PIN] മോഡ് [MODE] സെറ്റ് ചെയ്യുക",
    "arduinoEsp32.pins.setDigitalOutput":
        "ഡിജിറ്റൽ പിൻ [PIN] ഔട്ട് [LEVEL] സെറ്റ് ചെയ്യുക",
    "arduinoEsp32.pins.setPwmOutput":
        "PWM പിൻ [PIN] ഔട്ട് [OUT] സെറ്റ് ചെയ്യുക",
    "arduinoEsp32.pins.readDigitalPin": "ഡിജിറ്റൽ പിൻ [PIN] റീഡ് ചെയ്യുക",
    "arduinoEsp32.pins.readAnalogPin": "അനലോഗ് പിൻ [PIN] റീഡ് ചെയ്യുക",
    "arduinoEsp32.pins.setServoOutput":
        "സെർവോ പിൻ [PIN] ഔട്ട് [OUT] സെറ്റ് ചെയ്യുക",
    "arduinoEsp32.pins.attachInterrupt":
        "ഇന്ററപ്റ്റ് പിൻ [PIN] മോഡ് [MODE] അറ്റാച്ച് ചെയ്യുക",
    "arduinoEsp32.pins.detachInterrupt":
        "ഇന്ററപ്റ്റ് പിൻ [PIN] ഡിറ്റാച്ച് ചെയ്യുക",
    "arduinoEsp32.serial.serialBegin": "സീരിയൽ തുടങ്ങുക ബോഡ്‌റേറ്റ് [VALUE]",
    "arduinoEsp32.serial.serialPrint": "സീരിയൽ പ്രിന്റ് [VALUE] [EOL]",
    "arduinoEsp32.serial.serialAvailable": "സീരിയൽ ലഭ്യമായ ഡാറ്റ നീളം",
    "arduinoEsp32.serial.serialReadAByte": "സീരിയൽ ഒരു ബൈറ്റ് റീഡ് ചെയ്യുക",
    "arduinoEsp32.data.dataMap":
        "[DATA] നെ ([ARG0], [ARG1]) ൽ നിന്ന് ([ARG2], [ARG3]) ലേക്ക് മാപ്പ് ചെയ്യുക",

    // Arduino ESP8266 Blocks
    "arduinoEsp8266.modeMenu.input": "ഇൻപുട്ട്",
    "arduinoEsp8266.modeMenu.output": "ഔട്ട്പുട്ട്",
    "arduinoEsp8266.modeMenu.inputPullup": "ഇൻപുട്ട്-പുൾഅപ്പ്",
    "arduinoEsp8266.levelMenu.high": "ഹൈ (High)",
    "arduinoEsp8266.levelMenu.low": "ലോ (Low)",
    "arduinoEsp8266.pins.setPinMode": "പിൻ [PIN] മോഡ് [MODE] സെറ്റ് ചെയ്യുക",
    "arduinoEsp8266.pins.setDigitalOutput":
        "ഡിജിറ്റൽ പിൻ [PIN] ഔട്ട് [LEVEL] സെറ്റ് ചെയ്യുക",
    "arduinoEsp8266.pins.setPwmOutput":
        "PWM പിൻ [PIN] ഔട്ട് [OUT] സെറ്റ് ചെയ്യുക",
    "arduinoEsp8266.pins.readDigitalPin": "ഡിജിറ്റൽ പിൻ [PIN] റീഡ് ചെയ്യുക",
    "arduinoEsp8266.pins.readAnalogPin": "അനലോഗ് പിൻ [PIN] റീഡ് ചെയ്യുക",
    "arduinoEsp8266.pins.setServoOutput":
        "സെർവോ പിൻ [PIN] ഔട്ട് [OUT] സെറ്റ് ചെയ്യുക",
    "arduinoEsp8266.pins.attachInterrupt":
        "ഇന്ററപ്റ്റ് പിൻ [PIN] മോഡ് [MODE] അറ്റാച്ച് ചെയ്യുക",
    "arduinoEsp8266.pins.detachInterrupt":
        "ഇന്ററപ്റ്റ് പിൻ [PIN] ഡിറ്റാച്ച് ചെയ്യുക",
    "arduinoEsp8266.serial.serialBegin": "സീരിയൽ തുടങ്ങുക ബോഡ്‌റേറ്റ് [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "സീരിയൽ പ്രിന്റ് [VALUE] [EOL]",
    "arduinoEsp8266.serial.serialAvailable": "സീരിയൽ ലഭ്യമായ ഡാറ്റ നീളം",
    "arduinoEsp8266.serial.serialReadAByte": "സീരിയൽ ഒരു ബൈറ്റ് റീഡ് ചെയ്യുക",
    "arduinoEsp8266.data.dataMap":
        "[DATA] നെ ([ARG0], [ARG1]) ൽ നിന്ന് ([ARG2], [ARG3]) ലേക്ക് മാപ്പ് ചെയ്യുക",
    // Additional Data Blocks
    "arduinoUno.data.dataConstrain":
        "[DATA] നെ ([ARG0], [ARG1]) ൽ പരിമിതപ്പെടുത്തുക",
    "arduinoUno.data.dataConvert": "[DATA] നെ [TYPE] ലേക്ക് മാറ്റുക",
    "arduinoUno.data.dataConvertASCIICharacter":
        "[DATA] നെ ASCII അക്ഷരത്തിലേക്ക് മാറ്റുക",
    "arduinoUno.data.dataConvertASCIINumber":
        "[DATA] നെ ASCII നമ്പറിലേക്ക് മാറ്റുക",
    "arduinoUno.dataTypeMenu.integer": "പൂർണ്ണസംഖ്യ",
    "arduinoUno.dataTypeMenu.decimal": "ദശാംശം",
    "arduinoUno.dataTypeMenu.string": "സ്ട്രിംഗ്",

    "arduinoNano.data.dataConstrain":
        "[DATA] നെ ([ARG0], [ARG1]) ൽ പരിമിതപ്പെടുത്തുക",
    "arduinoNano.data.dataConvert": "[DATA] നെ [TYPE] ലേക്ക് മാറ്റുക",
    "arduinoNano.data.dataConvertASCIICharacter":
        "[DATA] നെ ASCII അക്ഷരത്തിലേക്ക് മാറ്റുക",
    "arduinoNano.data.dataConvertASCIINumber":
        "[DATA] നെ ASCII നമ്പറിലേക്ക് മാറ്റുക",
    "arduinoNano.dataTypeMenu.integer": "പൂർണ്ണസംഖ്യ",
    "arduinoNano.dataTypeMenu.decimal": "ദശാംശം",
    "arduinoNano.dataTypeMenu.string": "സ്ട്രിംഗ്",

    "arduinoLeonardo.data.dataConstrain":
        "[DATA] നെ ([ARG0], [ARG1]) ൽ പരിമിതപ്പെടുത്തുക",
    "arduinoLeonardo.data.dataConvert": "[DATA] നെ [TYPE] ലേക്ക് മാറ്റുക",
    "arduinoLeonardo.data.dataConvertASCIICharacter":
        "[DATA] നെ ASCII അക്ഷരത്തിലേക്ക് മാറ്റുക",
    "arduinoLeonardo.data.dataConvertASCIINumber":
        "[DATA] നെ ASCII നമ്പറിലേക്ക് മാറ്റുക",
    "arduinoLeonardo.dataTypeMenu.integer": "പൂർണ്ണസംഖ്യ",
    "arduinoLeonardo.dataTypeMenu.decimal": "ദശാംശം",
    "arduinoLeonardo.dataTypeMenu.string": "സ്ട്രിംഗ്",

    "arduinoMega2560.data.dataConstrain":
        "[DATA] നെ ([ARG0], [ARG1]) ൽ പരിമിതപ്പെടുത്തുക",
    "arduinoMega2560.data.dataConvert": "[DATA] നെ [TYPE] ലേക്ക് മാറ്റുക",
    "arduinoMega2560.data.dataConvertASCIICharacter":
        "[DATA] നെ ASCII അക്ഷരത്തിലേക്ക് മാറ്റുക",
    "arduinoMega2560.data.dataConvertASCIINumber":
        "[DATA] നെ ASCII നമ്പറിലേക്ക് മാറ്റുക",
    "arduinoMega2560.dataTypeMenu.integer": "പൂർണ്ണസംഖ്യ",
    "arduinoMega2560.dataTypeMenu.decimal": "ദശാംശം",
    "arduinoMega2560.dataTypeMenu.string": "സ്ട്രിംഗ്",

    "arduinoEsp32.data.dataConstrain":
        "[DATA] നെ ([ARG0], [ARG1]) ൽ പരിമിതപ്പെടുത്തുക",
    "arduinoEsp32.data.dataConvert": "[DATA] നെ [TYPE] ലേക്ക് മാറ്റുക",
    "arduinoEsp32.data.dataConvertASCIICharacter":
        "[DATA] നെ ASCII അക്ഷരത്തിലേക്ക് മാറ്റുക",
    "arduinoEsp32.data.dataConvertASCIINumber":
        "[DATA] നെ ASCII നമ്പറിലേക്ക് മാറ്റുക",
    "arduinoEsp32.dataTypeMenu.integer": "പൂർണ്ണസംഖ്യ",
    "arduinoEsp32.dataTypeMenu.decimal": "ദശാംശം",
    "arduinoEsp32.dataTypeMenu.string": "സ്ട്രിംഗ്",

    "arduinoEsp8266.data.dataConstrain":
        "[DATA] നെ ([ARG0], [ARG1]) ൽ പരിമിതപ്പെടുത്തുക",
    "arduinoEsp8266.data.dataConvert": "[DATA] നെ [TYPE] ലേക്ക് മാറ്റുക",
    "arduinoEsp8266.data.dataConvertASCIICharacter":
        "[DATA] നെ ASCII അക്ഷരത്തിലേക്ക് മാറ്റുക",
    "arduinoEsp8266.data.dataConvertASCIINumber":
        "[DATA] നെ ASCII നമ്പറിലേക്ക് മാറ്റുക",
    "arduinoEsp8266.dataTypeMenu.integer": "പൂർണ്ണസംഖ്യ",
    "arduinoEsp8266.dataTypeMenu.decimal": "ദശാംശം",
    "arduinoEsp8266.dataTypeMenu.string": "സ്ട്രിംഗ്",
    // Library manager & Board manager
    "gui.librariesBoardsTab": "ലൈബ്രറികൾ",
    "gui.boardManagerTab": "ബോർഡ് മാനേജർ",

    "gui.boardManager.title": "ബോർഡ് മാനേജർ",
    "gui.boardManager.description":
        "ഔദ്യോഗിക Arduino ബോർഡുകൾ തിരയുകയും ഇൻസ്റ്റാൾ ചെയ്യുകയും ചെയ്യുക.",
    "gui.boardManager.searchPlaceholder": "Arduino ബോർഡ് തിരയുക (ഉദാ: esp32)",
    "gui.boardManager.search": "തിരയുക",
    "gui.boardManager.searching": "തിരയുന്നു...",
    "gui.boardManager.advancedOptionsShow":
        "▶ നൂതന ഓപ്ഷനുകൾ (കസ്റ്റം ഇൻസ്റ്റാൾ പാത)",
    "gui.boardManager.advancedOptionsHide": "▼ നൂതന ഓപ്ഷനുകൾ മറയ്ക്കുക",
    "gui.boardManager.recommended": "ശുപാർശ ചെയ്‌ത",
    "gui.boardManager.installed": "ഇൻസ്റ്റാൾ ചെയ്‌തത് ({count})",
    "gui.boardManager.searchResults": "തിരയൽ ഫലങ്ങൾ {count}",
    "gui.boardManager.refresh": "↻ റിഫ്രെഷ്",
    "gui.boardManager.refreshing": "↻ റിഫ്രെഷ് ചെയ്യുന്നു...",

    "gui.libraryManager.title": "ലൈബ്രറി മാനേജർ",
    "gui.libraryManager.description":
        "ഔദ്യോഗിക Arduino ലൈബ്രറികൾ തിരയുകയും ഇൻസ്റ്റാൾ ചെയ്യുകയും ചെയ്യുക.",
    "gui.libraryManager.searchPlaceholder":
        "Arduino ലൈബ്രറി തിരയുക (ഉദാ: Servo)",
    "gui.libraryManager.search": "തിരയുക",
    "gui.libraryManager.searching": "തിരയുന്നു...",
    "gui.libraryManager.advancedOptionsShow":
        "▶ നൂതന ഓപ്ഷനുകൾ (കസ്റ്റം ഇൻസ്റ്റാൾ പാത)",
    "gui.libraryManager.advancedOptionsHide": "▼ നൂതന ഓപ്ഷനുകൾ മറയ്ക്കുക",
    "gui.libraryManager.recommended": "ശുപാർശ ചെയ്‌ത",
    "gui.libraryManager.installed": "ഇൻസ്റ്റാൾ ചെയ്‌തത് ({count})",
    "gui.libraryManager.searchResults": "തിരയൽ ഫലങ്ങൾ {count}",
    "gui.libraryManager.refresh": "↻ റിഫ്രെഷ്",
    "gui.libraryManager.refreshing": "↻ റിഫ്രെഷ് ചെയ്യുന്നു...",
    "gui.gui.librariesBoardsTab": "ലൈബ്രറികൾ",
    "gui.gui.boardsManagerTab": "ബോർഡ് മാനേജർ",
};

export default ml;
